const type = 'SET_TIMELINE_EVENTS_TO_PRE_PAID_LOADING';

const setTimelineEventsToPrePaidLoading = (data) => ({
  data,
  type,
});

export { type };
export default setTimelineEventsToPrePaidLoading;
